export default __webpack_public_path__ + "static/media/home_img.3a58f427.webp";